export default "<div class=\"o-flex o-flex--left o-flex--wrap o-flex-grow gw-fade-in\"> <a class=gw-alphabet-letter ng-click=$ctrl.scrollTo(letter) ng-class=\"{ 'is-disabled' : $ctrl.disableLetter(letter) }\" ng-repeat=\"letter in $ctrl.alphabet\"> {{ ::letter }} </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/common/directory/alphabet-strip/alphabet-strip.html
// module id = leMu
// module chunks = 1